import { useRef, useEffect, useState } from 'react';

export function useTraceUpdate(props) {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps);
    }
    prev.current = props;
  });
}

export const useIsFooterCtaVisible = ref => {
  const [isFooterCtaVisible, setIsFooterCtaVisible] = useState(false);
  const observerRef = useRef(null);

  const callback = ([entry]) => {
    if (!entry.isIntersecting) {
      setIsFooterCtaVisible(false);
    } else if (entry.isIntersecting) {
      setIsFooterCtaVisible(true);
    }
  };

  useEffect(() => {
    observerRef.current = new IntersectionObserver(callback, {
      threshold: 0.5
    });
  }, []);

  useEffect(
    () => {
      if (ref.current) {
        observerRef.current.observe(ref.current);
      }

      return () => {
        if (ref.current) {
          observerRef.current.disconnect();
        }
      };
    },
    [ref]
  );

  return isFooterCtaVisible;
};
